import { every, isArray } from 'lodash-es'

import {
  SortFilterTraitFilter,
  SortFilterTraitSort,
} from '../../types/sort-filter-trait'

export const isValidSortFilterTraitSort = (
  potentialSort: unknown | SortFilterTraitSort[],
): potentialSort is SortFilterTraitSort[] => {
  if (!isArray(potentialSort)) return false
  if (potentialSort.length === 0) return true

  return every(potentialSort, (sort) => {
    return (
      'field' in sort &&
      'direction' in sort &&
      isArray(sort.field) &&
      sort.field.length > 0
    )
  })
}

export const isValidSortFilterTraitFilter = (
  potentialFilter: unknown | SortFilterTraitFilter[],
): potentialFilter is SortFilterTraitFilter[] => {
  if (!isArray(potentialFilter)) return false
  if (potentialFilter.length === 0) return true

  return every(potentialFilter, (filter) => {
    return 'field' in filter
  })
}

export const getInitialSortFromSearchParams = (): SortFilterTraitSort[] => {
  const urlSearchParams = new URLSearchParams(window.location.search)
  let potentialSort: SortFilterTraitSort[] | unknown = []

  try {
    potentialSort = JSON.parse(urlSearchParams.get('sort') || '[]')
  } catch (e) {
    console.warn('Invalid sort parameter in URL:', e)
    return []
  }

  if (Array.isArray(potentialSort)) {
    if (potentialSort.length > 0) {
      return potentialSort
    }

    if (isValidSortFilterTraitSort(potentialSort)) {
      return potentialSort
    }
  }

  return []
}

export const getInitialFiltersFromSearchParams =
  (): SortFilterTraitFilter[] => {
    const urlSearchParams = new URLSearchParams(window.location.search)
    let potentialFilter: SortFilterTraitFilter[] | unknown = []

    try {
      potentialFilter = JSON.parse(urlSearchParams.get('filter') || '[]')
    } catch (e) {
      console.warn('Invalid filter parameter in URL:', e)
      return []
    }

    if (Array.isArray(potentialFilter)) {
      if (potentialFilter.length > 0) {
        return potentialFilter
      }

      if (isValidSortFilterTraitFilter(potentialFilter)) {
        return potentialFilter
      }
    }

    return []
  }
